export const TRANSLATIONS_EN_CHAT_TASKS_AND_PROFILE = {
  "tasks.process_document_a": "Process document A",
  "tasks.extract_entities_a": "Extract entities from document A",
  "tasks.classify_document_b": "Classify document B",
  "tasks.classify_b_desc": "Automatic classification of document B",
  "tasks.index_document_c": "Index document C",
  "tasks.index_c_desc": "Index document C for search",
  "tasks.summarize_document_d": "Summarize document D",
  "tasks.summarize_d_desc": "Automatic summary generation",
  "chat.title": "Document Assistant",
  "chat.grounding.evidence.aria": "Evidence status",
  "chat.grounding.evidence.grounded": "Backed by documents",
  "chat.grounding.evidence.partially_grounded": "Partially backed",
  "chat.grounding.evidence.no_evidence": "No documentary evidence",
  "chat.grounding.evidence.validation_failed": "Could not validate evidence",
  "chat.grounding.evidence.retrieval_failed": "Could not retrieve evidence",
  "chat.grounding.evidence.unknown": "Evidence undetermined",
  // Warnings (P2-1): `retrieval_failed` is NOT `no_evidence` — nothing was retrieved
  // because of a failure, which is not the same as there being nothing. Copy differs.
  "chat.grounding.evidence.warning.partially_grounded": "This answer rests on only part of the available evidence and may be incomplete. Check the sources before relying on any figures or dates.",
  "chat.grounding.evidence.warning.no_evidence": "No documents were retrieved for this question: this answer is not backed by your documents.",
  "chat.grounding.evidence.warning.validation_failed": "It could not be validated that this answer matches the retrieved documents. Check the sources before relying on any figures or dates.",
  "chat.grounding.evidence.warning.retrieval_failed": "Evidence could not be retrieved because of a system error. This answer is not backed by your documents; please try again.",
  "chat.generation.proposal.generateHere": "Generate here",
  "chat.generation.enqueued": "Your summary is being processed. Click here to see the progress.",
  "chat.generation.viewProgress": "View in Generated Documents",
  "chat.generation.forbidden": "Your plan does not allow generating summaries or the quota was reached.",
  "chat.generation.error": "The generation could not be enqueued.",
  "chat.generation.proposal.button": "Generate executive summary",
  "chat.generation.proposal.fallback": "I can generate an executive summary from your documents. Shall I?",
  "chat.generation.generateSummary": "Generate Summary",
  "chat.generation.defaultHint": "Generate an executive summary of my documents",
  "chat.plus.menuLabel": "Actions",
  "chat.plus.modeSection": "Search type",
  "chat.generation.candidatesQuestion": "I found these documents for your summary. Shall I generate it with them?",
  "chat.generation.proposal.confirm": "Yes, generate summary",
  "chat.generation.proposal.adjust": "Adjust in the wizard",
  "chat.generation.unnamedDoc": "Document",
  "chat.generation.armedPlaceholder": "Describe the summary you want to generate…",
  "chat.generation.armedCancel": "Cancel Generate Summary",
  "chat.placeholder": "Type your message...",
  "chat.send": "Send",
  "chat.clear": "Clear chat",
  "chat.show_details": "Show details",
  "chat.hide_details": "Hide details",
  "chat.selected_source": "Selected source",
  "chat.location": "Location",
  "chat.chunk": "Chunk",
  "chat.typing": "Typing...",
  "chat.sources": "Sources",
  // `score` is the retrieval cosine similarity, not a confidence measure over the answer.
  "chat.relevance": "Relevance",
  "chat.error.unsupportedQuestion": "Sorry, I did not understand the type of question. Could you give me more context or details?",
  "chat.error.unexpected": "An unexpected error occurred.",
  "chat.error.unknownResponse": "Unknown response from the system.",
  "chat.feedback": "Was this answer helpful?",
  "chat.yes": "Yes",
  "chat.no": "No",
  "chat.feedback_comment": "Add a comment (optional)",
  "chat.feedback_thanks": "Thank you for your feedback!",
  "chat.recover": "Recover chat",
  "chat.new_session": "New session",
  "chat.close": "Close chat",
  "chat.message_change_name_success": "Chat name successfully updated.",
  "chat.search_type": "Search type",
  "chat.search_type.light": "Light",
  "chat.search_type.default": "Default",
  "chat.search_type.medium": "Medium",
  "chat.search_type.strong": "Strong",
  "chat.input_placeholder": "Ask anything",
  "chat.edit_message": "Edit message",
  "chat.edit": "Edit",
  "chat.copy_message": "Copy message",
  "chat.like_message": "Like",
  "chat.dislike_message": "Dislike",
  "chat.deselect_message": "Deselect message",
  "chat.copied": "Copied",
  "chat.download_document": "Download document",
  "chat.documents": "Documents",
  "chat.document": "Document",
  "chat.double_click_hint": "Double-click to view sources",
  "chat.click_to_read_source": "Click to read this source",
  "chat.fragment_text": "Cited excerpt",
  "chat.star_rating_title": "{{count}} stars",
  "chat.downloaded": "Downloaded",
  "chat.close_detail": "Close detail",
  "chat.session_name_empty_error": "Name cannot be empty.",
  "chat.session_untitled": "Untitled session",
  "chat.rename": "Rename",
  "chat.save": "Save",
  "chat.cancel": "Cancel",
  "chat.no_previous_sessions": "No previous sessions.",
  "tasks.pending": "Pending Tasks",
  "tasks.processed": "Processed Tasks",
  "tasks.created": "Created Tasks",
  "tasks.processed_at": "Processed at",
  "tasks.loading": "Loading tasks...",
  "tasks.status": "Status",
  "tasks.step": "Step",
  "tasks.description": "Description",
  "tasks.created_by": "Created by",
  "tasks.no_processed": "No processed tasks yet.",
  "tasks.filters": "Filters",
  "tasks.filter_by_id": "Filter by Task ID",
  "tasks.filter_by_date": "Filter by Date",
  "tasks.clear_filters": "Clear Filters",
  "tasks.no_pending": "No pending tasks.",
  "profile.name": "Name",
  "profile.email": "Email",
  "profile.company": "Company",
  "profile.role": "Role",
  "profile.title": "Profile",
  "profile.section_personal": "Personal information",
  "profile.section_organization": "Organization",
  "profile.country": "Country",
  "profile.country_select": "Select a country",
  "profile.section_preferences": "Preferences",
  "profile.email_managed": "Email managed by the system",
  "profile.role_managed": "Role managed by the system",
  "profile.job_title": "Job Title",
  "profile.organization_type": "Organization Type",
  "profile.organization_size": "Organization Size",
  "profile.loading": "Loading profile...",
  "profile.loading_data": "Loading data...",
  "profile.save": "Save Profile",
  "profile.save_success": "Profile saved successfully.",
  "chat.inputmode_question": "Get information from document",
  "chat.inputmode_csv": "CSV query",
  "chat.inputmode_db": "Database query",
  "chat.inputmode_count_documents": "Count documents",
  "chat.no_sessions": "No sessions",
  "chat.tools": "Tools",
  "chat.expertRole.label": "Answer as…",
  "chat.expertRole.placeholder": "No role",
  "chat.expertRole.clear": "Clear expert",
  "chat.expertRole.applied": "Answered as",
  "chat.expertRole.notEntitled": "Your plan does not include expert roles",
  "chat.expertRole.degraded": "The selected role was not applied to this answer.",
  "chat.expertRole.messageBadge": "Expert query",
  "profile.change_photo": "Change photo",
  "profile.name_required": "Name is required.",
  "profile.load_error": "Error loading profile.",
  "profile.photo_upload_error": "Error uploading photo.",
  "profile.save_error": "Error saving profile.",
  "tasks.filter_by_status": "Filter by status",
  "tasks.filter_by_user": "Filter by user",
  "tasks.filter_by_description": "Filter by description",
};
